import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, IconButton,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useEffect } from "react";
import { FormContainer, PasswordElement, useForm } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

import { useChangeUserPasswordMutation } from "@/api/hooks/user-hooks";
import { ChangePasswordRequestDto } from "@/shared/api";
import { Autorenew } from "@mui/icons-material";

const ChangeUserPasswordModal = ({
  userId,
  onClose,
  onSuccess,
  open = false,
}: {
  userId: number;
  onClose: () => void;
  onSuccess?: () => void;
  open?: boolean;
}) => {
  const { t } = useTranslation();
  const { mutate: changePassword, isPending } = useChangeUserPasswordMutation();
  const form = useForm<ChangePasswordRequestDto>({ defaultValues: { id: userId } });

  const handleOnSuccess = (data: ChangePasswordRequestDto) => {
    changePassword(
      {
        userId: userId,
        password: data.password,
      },
      {
        onSuccess: () => {
          onClose();
          onSuccess && onSuccess();
          enqueueSnackbar("Password successfully changed!", { variant: "success" });
        },
        onError: (err) => {
          console.error("change user password error:", err);
          enqueueSnackbar(`Something went wrong while changing password: ${err.message}`, {
            variant: "error",
          });
        },
      }
    );
  };

  useEffect(() => {
    if (!open) {
      form.reset();
    }
  }, [form, open]);

  function handleGeneratePasswordClick(): void {
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const digits = '0123456789';
    const specials = '!@#$%^&*()_-+=<>[]{}|~.:';
    const all = lower + upper + digits + specials;
    const length = 16;

    const get = (chars: string) => chars[Math.floor(Math.random() * chars.length)];
    const password = [
      get(lower), get(upper), get(digits), get(specials),
      ...Array.from({ length: length - 4 }, () => get(all))
    ];

    const newPassword = password.sort(() => Math.random() - 0.5).join('');

    form.setValue("password", newPassword);
    navigator.clipboard
      .writeText(newPassword)
      .then(() =>
        enqueueSnackbar(t("Generated password copied to clipboard"), { variant: "info" })
      );
  }

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{t("changeUserPassword")}</DialogTitle>

      <FormContainer formContext={form} onSuccess={(data) => handleOnSuccess(data)}>
        <DialogContent>
          {/*<TextFieldElement*/}
          {/*  autoFocus*/}
          {/*  name="passowrd"*/}
          {/*  required*/}
          {/*  label="New password"*/}
          {/*  variant="outlined"*/}
          {/*/>*/}
          <Box display="flex" alignItems="center" gap={1}>
            <PasswordElement
              autoFocus
              name="password"
              label={t("password")}
              required
              fullWidth
            />

            <div>
              <IconButton
                onClick={handleGeneratePasswordClick}
                size="small"
                sx={{
                  position: "absolute",
                  right: 83,          // сдвиг левее
                  top: "62,5%",         // сдвиг ниже
                  transform: "translateY(-50%)",
                  border: "1px solid #ccc",
                  width: 32,
                  height: 32,
                  zIndex: 1,
                  borderStyle: "none",
                }}
              >
                <Autorenew  fontSize="small" />
              </IconButton>
            </div>
          </Box>

        </DialogContent>

        <DialogActions>
          <Button
            type="submit"
            endIcon={isPending ? <CircularProgress color="inherit" size={20} /> : undefined}
          >
            {t("save")}
          </Button>
        </DialogActions>
      </FormContainer>
    </Dialog>
  );
};

export default ChangeUserPasswordModal;
